import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthProvider } from '@praxis/component-auth'
import Main from './layout'
import apiConfig from './apiConfig'
import { STG_API_KEY, PRD_API_KEY } from './apiConfig'
import { Interceptor } from './services/httpInterceptor'
import { OpenTelemetryManager } from '@measurement/opentelemetry-web'
import DeploymentBanner from './components/DeploymentBanner'
import { handleChunkLoadErrors } from './helpers/versionCheck'
import './imageInterceptor'
const environment = ['qa', 'pol_dev'].includes(process.env.REACT_APP_ENV)
  ? 'dev'
  : ['partnersonline_stg', 'pol_stage', 'stg'].includes(
        process.env.REACT_APP_ENV
      )
    ? 'stage'
    : ['prod', 'pol_prod'].includes(process.env.REACT_APP_ENV)
      ? 'prod'
      : process.env.REACT_APP_ENV
const config = {
  apiKey: PRD_API_KEY,
  serviceName: 'photobridge',
  enableConsoleExporter: true,
  environment: environment,
}
OpenTelemetryManager.initialize(config)
handleChunkLoadErrors()

// Replace with your app’s unique Identity 2.0 client id
// see http://go/oauth to create or manage client ids
// const CLIENT_ID = 'ecgi_npe_im'

/* `App` composes our top-most app code, "Main", within two wrapping components.
  [1] 🗝️ the `AuthProvider` is our interface into Praxis Authentication.
      By default Identity 2.0 flows are full page redirects.
      The `AuthProvider` establishes an `AuthContext` which `Main` accesses via `useAuth`
  [2] 🛣️ the Router maintains where we are in the single-page javascript app
      Routes are defined in `Main`, with the `Switch` ensuring only `*Route` is rendered at a time
*/
const App = () => {
  return (
    <>
      <DeploymentBanner />
      <AuthProvider {...apiConfig.auth}>
        <Router>
          <Interceptor>
            <Main />
          </Interceptor>
        </Router>
      </AuthProvider>
    </>
  )
}
export default App
